<template>
  <van-popup round v-model="visible" closeable position="bottom" @close="visible = false">
    <div class="sac_p_0">
      <h4 class="div1">选择打印机</h4>
      <van-radio-group v-model="radio">
        <ul class="ul">
          <li v-for="(item, index) in list" :key="index">
            <van-radio :name="item.id" icon-size="20px" :checked-color="$theme.main_color_btn_bg">{{item.deviceCode}}</van-radio><span class="coe1">已默认</span>
          </li>
        </ul>
      </van-radio-group>
      <div class="footer">
        <div class="btn gry" @click="visible = false">取消打印</div>
        <div class="btn wit" @click="checkFun">打印</div>
      </div>
    </div>
  </van-popup>
</template>
<script>

import http from "@/utils/axios";
export default { 
  name: '',
  props: {
    
  },
  data() {
    return {
      visible: false,
      radio: '',
      list:[]
    }
  },
  methods: {
    checkFun(){
      this.$emit('callback', this.radio)
      this.visible = false
    },
    init(){
      http({
        url: "order/admin/express/printConfig/defaultPrinter/3",
        method: "get"
      })
        .then((rps) => {
          this.$loading.hide()
          this.list.push(rps.data)
          this.visible =  true
        })
        .catch((rps) => {
          this.$loading.hide()
        });
    }
  },
  created() {
  },
  mounted(){},
  components: {},
};
</script>
<style lang="less" scoped>
.sac_p_0{
  padding-left: 30px;
  padding-right: 30px;
  .div1{
    font-size: 32px;
    margin-top: 33px;
    margin-bottom: 30px;
    text-align: center;
  }
  .ul{
    padding-left: 50px;
    >li{
      line-height: 104px;
      height: 104px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1PX solid #F2F2F2;;
      .coe1{
        color: #F8A651;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
  .footer{
    margin-top: 81px;
    padding-bottom: 40px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    justify-content: space-between;
    .btn{
      width: 298px;
      height: 68px;
      line-height: 68px;
      text-align: center;
      border-radius: 32px;
    }
    .gry{
      background: #FFFFFF;
      border: 1PX solid #999999;
      color: #999999;
    }
    .wit{
      background: var(--epButtonColor);
      color: var(--epTextColor);
      border: 1PX solid var(--epButtonColor);
    }
  }
}
</style>
